import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { MatDialog } from '@angular/material';

import { DataService } from '../data.service';
import { Menu2Component } from '../menu2/menu2.component';
import { modelMenu } from '../../model/menu';


@Component({
  selector: 'app-menu',
  templateUrl: './menu.component.html',
  styleUrls: ['./menu.component.css']
})
export class MenuComponent implements OnInit {
  theme:string="";
  errMsg:string="";
  modMenu:modelMenu[]=[];
  modMenu2:modelMenu[]=[];

  constructor(private dataService: DataService, private router:Router, public dialog: MatDialog) {
    this.dataService.infoApp();    
   }

  ngOnInit() {
    this.dataService.getMenu().subscribe(
      row => { this.modMenu = <any>row; },
      error => this.errMsg = <any>error,
      () => this.fnMenuCargado()
    );
    this.dataService.getMenu2().subscribe(
      row => { this.modMenu2 = <any>row; },
      error => this.errMsg = <any>error,
      () => console.log("menu cargado")
    );
    document.getElementById("divLogo").style.animationName = 'aniLogo'; 
    document.getElementById("divLogo").style.animationDuration = '4s';    
  }

  fnMenuCargado(){
    //console.log(this.modMenu);
    var auxMenu;
    setTimeout(() => {
      for(var i=0; i < this.modMenu.length; i++){
        auxMenu = document.getElementById("divItemImagen_"+this.modMenu[i].a);
        if(this.modMenu[i].i)
          auxMenu.style.backgroundImage = "url('/assets/imgs/hup/" + this.modMenu[i].i + "')";
      }      
    }, 15);
  }

  fnClickMenuItem(event, i){
    //console.log(i);
    if(i.a.substr(0,1)=="_"){
      //console.log("MOSTRAR 2do NIVEL: " + i.a);
      var auxMenuItems = document.getElementById("trMenuItems");
      var auxMenu = document.getElementById("divItemMenu_" + i.a);
      var itemTop = Number(auxMenuItems.offsetTop) + Number(auxMenu.offsetTop) + Number(auxMenu.clientTop);
      itemTop = event.clientY;
      var itemRight = Number(auxMenu.offsetLeft) + Number(auxMenu.clientLeft) + Number(auxMenu.clientWidth) - 50;
      //console.log(itemTop  + ", " + itemRight);
      auxMenuItems.style.opacity = "0.7";
      auxMenuItems.style.backgroundColor = 'rgba(210,210,210,.15)';
      let dialogRef = this.dialog.open(Menu2Component, {
        width: '200px',
        hasBackdrop: true,
        backdropClass: 'clsMenu2Fondo',
        panelClass: 'clsMenu2Dialog',
        position: { top: itemTop.toString() + 'px', left: itemRight.toString() + 'px'},
        disableClose: false,
        data: { nivel1: i.a, modMenu2: this.modMenu2 }
      });
      dialogRef.afterClosed().subscribe(result => {
        auxMenuItems.style.opacity = "1";
        auxMenuItems.style.backgroundColor = 'transparent';
      });
    }
    else{
      this.router.navigate([i.a]);
    }
  }
}
